import React from "react"
import { Container, Typography } from "@material-ui/core"
import { AppStyles } from "assets/styles/App"
import { graphql, Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import moement from "moment"
interface Props {}

const AboutMe: React.FC<Props> = () => {
  const classes = AppStyles()

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "arif.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const renderAge = () => {
    let age: number = 0
    const now: string = moement(new Date()).format("YYYY")
    age = parseInt(now) - 1993

    return age
  }

  return (
    <div className={classes.featuredOuter}>
      <Container maxWidth="md">
        <Typography
          className={classes.heroTitle}
          variant="h2"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          About Myself<span role="img">😎</span>
        </Typography>
        <Container className={classes.aboutMeCont} maxWidth={false}>
          <Img
            className={`${classes.avatar} slide-in-left`}
            fluid={data.file.childImageSharp.fluid}
            alt="Arif"
          />
          <Container
            maxWidth={false}
            className={`${classes.aboutMeText} slide-in-right`}
          >
            <Typography
              className={classes.heroDesc}
              variant="h5"
              color="textPrimary"
              paragraph
            >
              I am currently working in Petaling Jaya, Selangor, Malaysia. Aside
              from working, I love to code on my own projects and products.
              <br />
              <br />I consider myself as an explorer. I like to explore new
              things, not only related to programming. Recently, I have started
              my journey to learn more about coffee art. Got my hands dirty with
              the espresso making and latte art <span role="img">☕</span>. I
              love the experience of making new cup of coffee and get inspired
              with it. <Link to="about-me">Read More...</Link>
            </Typography>
          </Container>
        </Container>
      </Container>
    </div>
  )
}

export default AboutMe
